import { useLanguage } from "@/i18n/LanguageContext";

const testimonials = [
  {
    name: "M.R.",
    location: "Brickell",
    rating: 5,
    key: "home.testimonial1",
  },
  {
    name: "L.S.",
    location: "Coral Gables",
    rating: 5,
    key: "home.testimonial2",
  },
  {
    name: "J.A.",
    location: "Aventura",
    rating: 5,
    key: "home.testimonial3",
  },
];

export default function TestimonialsSection() {
  const { t } = useLanguage();

  return (
    <section className="w-full bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-black text-secondary mb-3">
            {t("home.testimonialsTitle")}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((tItem) => (
            <div
              key={tItem.name}
              className="bg-[#fefce8] rounded-xl p-6 md:p-8 border-l-4 border-primary"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: tItem.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent text-sm" />
                ))}
              </div>
              <p className="text-sm md:text-base text-secondary leading-relaxed mb-6 italic">
                &ldquo;{t(tItem.key)}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-white font-bold text-sm">
                  {tItem.name}
                </div>
                <div>
                  <p className="text-sm font-bold text-secondary">{tItem.name}</p>
                  <p className="text-xs text-[#374151]">{tItem.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}